import React from "react";
import HeroSection from "./HeroSection";
import Home2 from "./Home2";

function Home() {
  return (
    <section id="home">
      {/* Section 1: Terminal Hero — system.greet() + portrait backdrop */}
      <HeroSection />

      {/* Section 2: Learn About Me — stacked hero photos */}
      <Home2 />
    </section>
  );
}

export default Home;

